import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import UploadButton from "../components/UploadButton";
import { toast } from "sonner";
import Seo from "../components/Seo";

export default function Flash() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: "", image_url: "", price: 0, size: "", slots: 1, expiry_date: "" });

  const load = () => api.get("/flash").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/flash", { ...form, price: Number(form.price), slots: Number(form.slots) });
      toast.success("Flash posted"); setShowForm(false); load();
    } catch { toast.error("Failed to post"); }
  };

  const claim = async (f) => {
    if (!user) { toast.error("Sign in to claim"); return; }
    try {
      await api.post("/bookings", {
        artist_id: f.artist_id,
        preferred_date: new Date(Date.now() + 86400000).toISOString().slice(0,10),
        body_placement: "TBD",
        description: `Claim flash: ${f.title}`,
        reference_image_url: f.image_url,
        flash_id: f.id,
      });
      toast.success("Booking request sent for this flash");
    } catch { toast.error("Could not claim"); }
  };

  return (
    <div className="container-x py-12" data-testid="flash-page">
      <Seo title="Flash drops" description="Ready-to-tattoo flash designs released by artists on Inkstead."/>
      <div className="flex items-end justify-between">
        <div>
          <h1 className="font-serif text-4xl md:text-5xl">Flash drops</h1>
          <p className="text-black/60 mt-2">Ready-to-ink designs, limited slots.</p>
        </div>
        {user?.account_type === "artist" && (
          <button onClick={() => setShowForm(!showForm)} className="btn-filled" data-testid="flash-new-toggle">{showForm ? "Close" : "Post flash"}</button>
        )}
      </div>

      {showForm && (
        <form onSubmit={create} className="card mt-6 grid md:grid-cols-2 gap-4" data-testid="flash-form">
          <div className="md:col-span-2">
            <label className="text-sm font-medium block mb-1.5">Title</label>
            <input required className="input-field" value={form.title} onChange={(e)=>setForm({...form, title: e.target.value})} data-testid="flash-title"/>
          </div>
          <div className="md:col-span-2">
            <label className="text-sm font-medium block mb-1.5">Image URL</label>
            <div className="flex gap-2">
              <input required className="input-field" value={form.image_url} onChange={(e)=>setForm({...form, image_url: e.target.value})} placeholder="https://..." data-testid="flash-img"/>
              <UploadButton onUploaded={(url)=>setForm({...form, image_url: url})} label="Upload" testId="flash-upload"/>
            </div>
          </div>
          <div><label className="text-sm font-medium block mb-1.5">Price (USD)</label><input type="number" required className="input-field" value={form.price} onChange={(e)=>setForm({...form, price: e.target.value})} data-testid="flash-price"/></div>
          <div><label className="text-sm font-medium block mb-1.5">Size</label><input required className="input-field" value={form.size} onChange={(e)=>setForm({...form, size: e.target.value})} placeholder="e.g. 3in" data-testid="flash-size"/></div>
          <div><label className="text-sm font-medium block mb-1.5">Slots</label><input type="number" min={1} required className="input-field" value={form.slots} onChange={(e)=>setForm({...form, slots: e.target.value})} data-testid="flash-slots"/></div>
          <div><label className="text-sm font-medium block mb-1.5">Expiry date</label><input type="date" required className="input-field" value={form.expiry_date} onChange={(e)=>setForm({...form, expiry_date: e.target.value})} data-testid="flash-expiry"/></div>
          <div className="md:col-span-2"><button className="btn-filled" data-testid="flash-submit">Post flash</button></div>
        </form>
      )}

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
        {items.map((f) => (
          <div key={f.id} className="card !p-0 overflow-hidden" data-testid={`flash-${f.id}`}>
            <div className="aspect-[4/5] overflow-hidden"><img src={f.image_url} alt={f.title} className="w-full h-full object-cover"/></div>
            <div className="p-4">
              <div className="flex items-center justify-between">
                <h3 className="font-serif text-xl">{f.title}</h3>
                <span className="badge badge-flash">${f.price}</span>
              </div>
              <p className="text-sm text-black/60 mt-1">{f.size} · {f.slots} slots · by {f.artist_name}</p>
              <button onClick={()=>claim(f)} className="btn-outline w-full mt-4" data-testid={`flash-claim-${f.id}`}>Claim a slot</button>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-black/50 col-span-full">No flash drops right now.</p>}
      </div>
    </div>
  );
}
